import translate from '../../translations'

export default data => {
  const str = `
    <div class="card__visual">
        <img src="${data.imgSrc}" alt="">
        <div class="picto">
          <svg class="icon icon--blue-light mr-5" aria-hidden="true">
              <use href="#icon-print" xlink:href="#icon-print" />
          </svg>
        </div>
    </div>
    <div class="card__inner">
        <div class="card__top">
            <div class="card__heading">
                <span>
                    ${data.tag}
                </span>
            </div>
            <div class="card__content">
                <h2 class="card__title">${data.title}</h2>
                <div class="card__text">
                    ${data.desc}
                </div>
            </div>
        </div>
        <div class="card__bottom">
            <a href="${
  data.fileURL
}" class="link link--medium link--blue-light">
              <svg class="icon icon--blue-light mr-5" aria-hidden="true">
                  <use href="#icon-download" xlink:href="#icon-download" />
              </svg>
                ${translate('DOWNLOAD')}
            </a>
        </div>
    </div>`

  return str
}
